'use strict';

angular.module('portal.inspections')
    .controller('PortalInspection', ['$scope', 'Cache', '$stateParams', '$q', '$timeout', '$uibModal', '$state', '$rootScope', 'Documents', 'Session',
        function ($scope, Cache, $stateParams, $q, $timeout, $uibModal, $state, $rootScope, Documents, Session) {

            $scope.loading = true;
            $scope.saving = false;
            $scope.notInCache = false;
            $scope.inspectionID = $stateParams.id;
            $scope.inspection = $stateParams.inspection;
            $scope.showSaved = false;
            $scope.validationSuccess = false;
            $scope.validationMessage = null;
            $scope.checklist = {};
            $scope.deficiencyScore = { score: 0 };
            $scope.deficiencies = {
                fail: 0,
                pass: 0,
                ignore: 0
            }
            $scope.documents = [];

            $scope.save = function (the_form) {
                Session.checkIn();
                $scope.saving = true;
                $scope.validationMessage = null;
                $scope.validationSuccess = false;
                $scope.showSaved = false;
                $scope.inspection.checklist.isFormValid = $scope.isFormValid(the_form, $scope.inspection, $scope.checklist);

                $scope.saveInspection($scope.inspection, $scope.checklist, $scope.deficiencies).then(function () {
                    //make the saving spinner stay for a bit, otherwise it's so fast you can't even see it
                    var saveTimeout = $timeout(function () {
                        $scope.saving = false;
                        $scope.showSaved = true;
                    }, 500);

                    if ($scope.inspection.checklist.isFormValid) {
                        $scope.validationMessage = "All required information has been supplied";
                        $scope.validationSuccess = true;
                    }
                    else {
                        $scope.validationMessage = "Checklist saved, but required information is missing";
                        $scope.validationSuccess = false;
                    }

                    var validationTimeout = $timeout(function () {
                        $scope.validationMessage = null;
                        $scope.validationSuccess = false;
                        $scope.showSaved = false;
                    }, 3000);

                    $scope.$on('$destroy', function () {
                        $timeout.cancel(saveTimeout);
                        $timeout.cancel(validationTimeout);
                    });
                })
            }

            $scope.saveAndExit = function (the_form) {
                $scope.saving = true;
                $scope.validationMessage = null;
                $scope.validationSuccess = false;
                $scope.showSaved = false;
                $scope.inspection.checklist.isFormValid = $scope.isFormValid(the_form, $scope.inspection, $scope.checklist);

                $scope.saveInspection($scope.inspection, $scope.checklist, $scope.deficiencies).then(function () {
                    if ($scope.inspection.checklist.isFormValid) {
                        var timer = $timeout(function () {
                            $scope.saving = false;
                            $state.go('portal.menus.inspections');
                        }, 100);
                        $scope.$on('$destroy', function () {
                            $timeout.cancel(timer);
                        });
                    }
                    else {
                        $uibModal.open({
                            animation: true,
                            templateUrl: 'templates/confirm/confirm.html',
                            controller: 'ConfirmModalController',
                            resolve: {
                                message: function () {
                                    return "Required fields are missing. Do you still want to leave?";
                                }
                            }
                        }).result.then(function (result) {
                            if (result) {
                                var timer = $timeout(function () {
                                    $scope.saving = false;
                                    $state.go('portal.menus.inspections');
                                }, 100);
                                $scope.$on('$destroy', function () {
                                    $timeout.cancel(timer);
                                });
                            }
                            else {
                                $scope.saving = false;
                            }
                        }, function () {
                            $scope.saving = false;
                        });
                    }
                });
            }

            $scope.saveInspection = function (inspection, checklist, deficiencies) {
                var d = $q.defer();

                if (checklist.signature != null) {
                    inspection.checklist.signature_photo_source = checklist.signature.toDataURL();
                }
                inspection.checklist.deficiencies_fail = deficiencies.fail;
                inspection.checklist.deficiencies_pass = deficiencies.pass;
                inspection.checklist.deficiencies_ignore = deficiencies.ignore;

                if ($scope.inspection.checklist.template.require_responsible_party_signoff === true
                    && ($scope.inspection.checklist.template.virtual_signature === false || ($scope.inspection.checklist.template.virtual_signature === true && $scope.inspection.checklist.signature_type_in_person === true))) {
                    $scope.inspection.checklist.checklist_signed = true;
                }

                if (!$scope.complete() || !$scope.failed()) {
                    inspection.reinspect = false;
                }
                if ($scope.complete()) {
                    inspection.outcome = !$scope.failed();
                }
                else {
                    inspection.outcome = null;
                }
                inspection.inspector_id = $rootScope.userAccount.inspector_id;
                inspection.inspector = {
                    id: $rootScope.userAccount.inspector_id,
                    name: $rootScope.userAccount.name
                }
                inspection.submitted = false;

                var inspectionStr = JSON.parse(JSON.stringify(inspection));
                Cache.save('inspection', inspectionStr).then(function () {
                    d.resolve();
                });

                return d.promise;
            }

            $scope.isFormValid = function (the_form, inspection, checklist) {
                var valid = the_form.$valid;

                if (valid && inspection.checklist.template.require_responsible_party_signature) {
                    if (checklist.signature != null && checklist.signature.isEmpty()) {
                        valid = false;
                    }
                    else {
                        valid = true;
                    }
                }

                return valid;
            }

            $scope.complete = function () {
                // This hasn't changed with the addition of scoring (170495). We can still use this to determine completeness even if it's being evaluated based on score.
                return $scope.deficiencies.fail + $scope.deficiencies.pass + $scope.deficiencies.ignore == $scope.inspection.checklist.template.deficiencies_total;
            }

            $scope.failed = function () {
                if ($scope.inspection.checklist.template.passing_score_type) {
                    return $scope.inspection.checklist.template.passing_score > $scope.deficiencyScore.score;
                }
                else {
                    return $scope.deficiencies.fail >= $scope.inspection.checklist.template.auto_fail;
                }
            }

            Cache.get('inspection', $stateParams.id).then(function (inspection) {
                if (inspection != null) {
                    $scope.inspection = inspection;
                    $scope.deficiencies.fail = inspection.checklist.deficiencies_fail != null ? inspection.checklist.deficiencies_fail : 0;
                    $scope.deficiencies.pass = inspection.checklist.deficiencies_pass != null ? inspection.checklist.deficiencies_pass : 0;
                    $scope.deficiencies.ignore = inspection.checklist.deficiencies_ignore != null ? inspection.checklist.deficiencies_ignore : 0;
                    $scope.passingChecklist = $scope.inspection.checklist.template;
                    $scope.passingChecklist.inspectionID = $scope.inspectionID;

                    if (inspection.checklist) { $scope.checklist = angular.copy(inspection.checklist); }

                    if ($scope.inspection.reinspection_date == null) {
                        $scope.inspection.reinspection_date = new Date();
                        $scope.inspection.reinspection_date.setHours(0, 0, 0, 0);
                        if ($scope.inspection.checklist.template.reinspection != null) {
                            $scope.inspection.reinspection_date.setDate($scope.inspection.reinspection_date.getDate() + $scope.inspection.checklist.template.reinspection);
                        }
                    }

                    if ($scope.inspection.checklist.template.require_responsible_party_signoff === true && ($scope.inspection.checklist.signature_type_in_person === null || $scope.inspection.checklist.signature_type_in_person === undefined)) {
                        $scope.inspection.checklist.signature_type_in_person = true;
                    }

                    $scope.loading = false;
                }
                else {
                    console.log('Inspection is not in cache');
                    $scope.loading = false;
                    $scope.notInCache = true;
                }
            });

            $scope.resize = function () {
                if (document != null && document.querySelector != null) {
                    $scope.canvas = document.querySelector('canvas.pad');

                    if ($scope.canvas != null && $scope.canvas.offsetWidth != null && $scope.canvas.offsetHeight != null && $scope.canvas.getContext != null) {
                        var ratio = Math.max(window.devicePixelRatio || 1, 1);
                        $scope.canvas.width = $scope.canvas.offsetWidth * ratio;
                        $scope.canvas.height = $scope.canvas.offsetHeight * ratio;
                        $scope.canvas.getContext("2d").scale(ratio, ratio);
                    }
                }
            }

            $scope.$on('$destroy', function () {
                // should maybe give this canvas an id
                var canvasScope = angular.element(document.querySelector('canvas.pad')).scope();
                if (canvasScope) {
                    canvasScope.$destroy();
                }
                angular.element(document.querySelector('canvas.pad')).remove();
                $scope.canvas = undefined;
                canvasScope = undefined;
                $scope.inspection = undefined;
                if ($scope.checklist.signature) {
                    $scope.checklist.signature.off();
                    $scope.checklist.signature = undefined;
                }
            });

            $scope.clearSignature = function () {
                // we need to clear out the values if we select "virtual" for signature, but we don't want to clear it out if its already signed
                if ($scope.inspection.checklist.signature_type_in_person == false && $scope.inspection.checklist.checklist_signed != true) {
                    $scope.inspection.checklist.signature_first_name = null;
                    $scope.inspection.checklist.signature_last_name = null;
                    $scope.inspection.checklist.signature_certification_number = null;
                    $scope.inspection.checklist.signature_photo_source = null;
                    $scope.checklist.signature = null;
                }
            }

            Documents.getDocumentsByInspection($scope.inspectionID).then(function (documents) {
                $scope.documents = documents;

                for (var i = 0; i < $scope.documents.length; i++) {
                    $scope.documents[i].link = $rootScope.portalURL + 'controller.cfm?method=publicPortalService.openDocument' + '&documentID=' + $scope.documents[i].id.toUpperCase() + '&code=' + $scope.documents[i].code;
                }
            });
        }])
    ;